import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {LayoutConfigService} from '../../../../../../../core/layout/services/layout-config.service';
import {NavController} from '@ionic/angular';
import {UserInfoProfile} from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import {UiBsTranslateService} from '@wlp/ui-bs-translate';
import {environment} from '../../../../../../../../environments/environment';
import {LayoutConfigModel} from '../../../../../../../core/layout/models/layout-config.model';
import {Storage} from '@ionic/storage';
import {UserInfoService} from '@wlp/ui-bs-login';

@Component({
  selector: 'app-insurance-dashboard',
  templateUrl: './insurance-dashboard.page.html',
  styleUrls: ['./insurance-dashboard.page.scss'],
})
export class InsuranceDashboardPage implements OnInit, OnDestroy {
  private langDefault: string;
  private destroy$: Subject<null> = new Subject();
  private typeMenuEnv = environment.keyStorage.menu;
  private layoutConfigValue: LayoutConfigModel;
  public userProfile: UserInfoProfile;
  public backgroundImage: string;
  public listData: any[];

  constructor(
    private layoutConfigService: LayoutConfigService,
    protected userInfoService: UserInfoService,
    private navCtrl: NavController,
    private translate: UiBsTranslateService,
    private storage: Storage,
  ) {
    this.backgroundImage = this.layoutConfigService.getConfig('wlTheme.header.background.image');
  }

  public ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    this.loadUser();
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadUser() {
    this.userInfoService
      .getInfoProfile()
      .then((res) => {
        this.userProfile = res;
        this.loadMenuInsurance();
      })
      .catch((error) => {
        this.navCtrl.navigateRoot(`/app/dashboard`);
      });
  }
  private loadMenuInsurance() {
    const menuStore = sessionStorage.getItem(this.typeMenuEnv);
    if (menuStore && JSON.parse(menuStore)) {
      const menuStructure: Array<any> = JSON.parse(sessionStorage.getItem(this.typeMenuEnv));
      const menuInsurance = menuStructure.filter(m => m.label == 'ASIDE_MENU.INSURANCE.TITLE');
      this.listData = menuInsurance[0].url;
    }
  }

  public goTo(url: string) {
    if (url != '#') {
      if (url.includes('http:') || url.includes('https:')) {
        window.open(url, '_blank');
      } else {
        return this.navCtrl.navigateRoot([`${url}`]);
      }
    }
  }

  public goBack() {
    this.navCtrl.navigateRoot('/app/dashboard');
  }
}
